import React from 'react';
import { Box, Skeleton } from '@mui/material';

export interface TableSkeletonProps {
  rows?: number;
  header?: boolean;
  height?: number;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ rows = 8, header = true, height }) => (
  <Box sx={{ p: 2 }}>
    {header && <Skeleton variant="rectangular" height={48} sx={{ mb: 1, borderRadius: 1 }} />}
    <Skeleton variant="rectangular" height={height ?? Math.max(200, rows * 48)} sx={{ borderRadius: 1 }} />
  </Box>
);

export default TableSkeleton;
